import { useContext } from 'react';
import { createContext } from 'react';

import { ResponsiveLayoutDesktopProps } from '../@types/ResponsiveLayoutDesktopProps';

export const ResponsiveLayoutDesktopContext = createContext<ResponsiveLayoutDesktopProps>(
	{} as ResponsiveLayoutDesktopProps,
);

ResponsiveLayoutDesktopContext.displayName = 'ResponsiveLayoutDesktop';

const ResponsiveLayoutDesktopProvider = (props: ResponsiveLayoutDesktopProps) => (
	<ResponsiveLayoutDesktopContext.Provider value={props}>{props.children}</ResponsiveLayoutDesktopContext.Provider>
);

export const useResponsiveLayoutDesktop = () => {
	const context = useContext(ResponsiveLayoutDesktopContext);

	return context;
};

export default ResponsiveLayoutDesktopProvider;
